var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.694,
    height: 17.55,
    viewBox: "0 0 6.005 4.643",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    color: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.9 0C.413 0 0 .376 0 .856V3.787c0 .48.414.857.9.857h4.206c.485 0 .899-.378.899-.858V1.417c0-.48-.414-.855-.899-.855H3.618l-.516-.35.026.022a.923.923 0 00-.617-.235zm0 .5h1.61c.115 0 .213.042.284.105l.013.012.659.445h1.64c.235 0 .399.163.399.355v2.37c0 .192-.164.357-.399.357H.9c-.234 0-.398-.165-.398-.358V.857C.5.665.665.499.899.499z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.737 1.269A1.05 1.05 0 001.69 2.314c0 .574.472 1.047 1.047 1.047a1.05 1.05 0 001.045-1.047c0-.575-.47-1.045-1.045-1.045zm0 .5a.54.54 0 01.545.545c0 .304-.24.547-.545.547a.544.544 0 01-.547-.547c0-.305.243-.545.547-.545z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.307 2.88a.25.25 0 000 .354l.536.533a.25.25 0 00.353 0 .25.25 0 000-.354l-.535-.533a.25.25 0 00-.354 0z"
  }))));
}
export default SvgBrowse;